export type ConfiguracaoMinimo = {
    vlPesoTotalPedidoMinimo: number | null;
    vlTotalPedidoMinimo: number | null;
};

export const initialConfiguracaoMinimo: ConfiguracaoMinimo = {
    vlPesoTotalPedidoMinimo: null,
    vlTotalPedidoMinimo: null,
};
